<script>
import ScholarshipSideDialog from "../ScholarshipSideDialog.vue";
import TheMeetingVotingTable from "../../Tables/Meeting/TheMeetingVotingTable.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import _ from "lodash";

export default {
  name: "TheMeetingVotingDialog",
  components: {
    ScholarshipSideDialog,
    TheMeetingVotingTable,
  },

  data() {
    return {
      selectStatement: [],
      sendSnackbar: false,
    };
  },

  computed: {
    ...mapState({
      dialogVote: state => state.scholarship_vote.dialogVote,
    }),
  },

  statementsVotes() {
    const statements = _.cloneDeep(this.statements);
  },

  methods: {
    ...mapMutations({
      setDialogFlag: 'scholarship_vote/setDialogFlag',
    }),

    ...mapActions({
      sendMemberVotes: 'scholarship_vote/sendMemberVotes',
    }),

    ...mapActions({
      closeDialog: 'scholarship_vote/closeDialog',
    }),

    async sendVoteMemberCommission() {
      await this.sendMemberVotes();

      this.sendSnackbar = true;
    }
  },
}
</script>

<template>
  <scholarship-side-dialog
    :visible="dialogVote"
    width="70vw"
    position-dialog="right"
    :persistent="true"
  >
    <v-card-title>
      Голосование комиссии

      <v-btn
        class="rounded-xl white--text ml-3"
        color="teal darken-3"
        @click="sendVoteMemberCommission"
      >
        Подтвердить
      </v-btn>
      <v-spacer/>
      <v-btn
        small
        icon
        @click="closeDialog"
      >
        <v-icon small>
          fa-times
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-divider/>

    <the-meeting-voting-table/>

    <v-snackbar
      v-model="sendSnackbar"
      :timeout="2000"
      color="teal darken-3"
      class="white--text text-center"
    >
      <v-icon small left>fa-check-circle</v-icon>Действие было успешно выполнено
    </v-snackbar>

  </scholarship-side-dialog>
</template>

<style scoped>

</style>